import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Checkbox extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool, // Same as disabled, but not greyed-out
    extraClass: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    title: PropTypes.string,
    renderNullAsFalse: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    readOnly: false,
    value: false,
    text: '',
    extraClass: undefined,
    title: '',
    renderNullAsFalse: false,
  };

  state = {
    saving: false,
  };

  handleClick(e) {
    const { value, disabled, readOnly, onClick } = this.props;
    const { saving } = this.state;
    if (disabled || readOnly || saving) return;

    const result = onClick(!value, e);
    if (result && typeof result.then === 'function') {
      this.setState({ saving: true });
      result.then(
        () => this.setState({ saving: false }),
        () => this.setState({ saving: false }),
      );
    }
  }

  render() {
    const { value, disabled, text, extraClass, title, renderNullAsFalse, readOnly } = this.props;
    const { saving } = this.state;
    const isDisabled = disabled || saving;

    return (
      <span
        className={classNames({ pointer: !isDisabled && !readOnly }, extraClass)}
        title={title}
        onClick={e => this.handleClick(e)}
      >
        {saving ? (
          <i
            style={{ verticalAlign: 'middle' }}
            className={classNames('fa fa-fw fa-spinner fa-spin', { margin5R: text })}
          />
        ) : (
          <i
            style={{ verticalAlign: 'middle' }}
            className={classNames({
              'fa fa-fw fa-check-square-o': value,
              'fa fa-fw fa-square-o':
                value === false || value === undefined || (value === null && renderNullAsFalse),
              'glyphicon glyphicon-pencil': value === null && !renderNullAsFalse,
              pointer: !isDisabled && !readOnly,
              disabled: isDisabled,
              'setting-disabled': isDisabled,
              margin5R: text,
            })}
          />
        )}
        {text}
      </span>
    );
  }
}
